import { defineMessages, IntlShape } from "react-intl";

import SavedAddress from "@mapmycustomers/shared/types/SavedAddress";
import { showModal } from "@mapmycustomers/ui";

import zIndices from "@app/styles/_z-index.module.scss";
import { getSavedAddressLine } from "@app/util/savedLocations/savedAddressList";

const messages = defineMessages({
  cancel: {
    id: "savedLocations.replaceConfirm.cancel",
    defaultMessage: "Cancel",
    description: "Cancel button of the confirmation to replace the rep's Home or Work",
  },
  content: {
    id: "savedLocations.replaceConfirm.content",
    defaultMessage:
      "Your {type, select, home {Home} work {Work} other {}} is {address} today. Only one {type, select, home {Home} work {Work} other {}} is allowed, so replacing it drops that address. Cancel and the place you just saved stays as it is.",
    description:
      "Body of the confirmation to replace the rep's Home or Work with a place just saved",
  },
  ok: {
    id: "savedLocations.replaceConfirm.ok",
    defaultMessage: "Replace",
    description: "Confirm button that replaces the rep's Home or Work with a place just saved",
  },
  title: {
    id: "savedLocations.replaceConfirm.title",
    defaultMessage: "Replace your {type, select, home {Home} work {Work} other {}}?",
    description: "Title of the confirmation to replace the rep's Home or Work",
  },
});

const showReplaceSavedLocationConfirm = (
  intl: IntlShape,
  current: SavedAddress,
  onOk: () => void
) =>
  showModal({
    cancelText: intl.formatMessage(messages.cancel),
    centered: true,
    content: intl.formatMessage(messages.content, {
      address: getSavedAddressLine(current),
      type: current.type,
    }),
    okText: intl.formatMessage(messages.ok),
    onOk,
    title: intl.formatMessage(messages.title, { type: current.type }),
    type: "confirm",
    zIndex: Number(zIndices.savedLocationDialog),
  });

export default showReplaceSavedLocationConfirm;
